export const CREATE_STORY_MODAL_CLOSE = 'CREATE_STORY_MODAL_CLOSE'
export const CREATE_STORY_MODAL_OPEN = 'CREATE_STORY_MODAL_OPEN'
export const CREATE_STORY_MODAL_CHANGE_FIELD = 'CREATE_STORY_MODAL_CHANGE_FIELD'
export const CREATE_STORY_MODAL_CHANGE_SAVING = 'CREATE_STORY_MODAL_CHANGE_SAVING'


const csmInit = {
  isOpen: false,
  name: false,
  classgroup: null,
  isSaving: false,
  onSubmit: null,
  treeNodes: {
    isFetching: true,
    data: [],
  },
}

export function createStoryModal(createStoryModal=csmInit, action) {
  switch(action.type) {
    case CREATE_STORY_MODAL_CLOSE:
      return csmInit
    case CREATE_STORY_MODAL_OPEN:
      return {
        ...csmInit,
        isOpen: true,
        onSubmit: action.onSubmit,
        treeNodes: action.treeNodes,
      }
    case CREATE_STORY_MODAL_CHANGE_FIELD:
      return {
        ...createStoryModal,
        [action.name]: action.value,
      }
    case CREATE_STORY_MODAL_CHANGE_SAVING:
      return {
        ...createStoryModal,
        isSaving: action.isSaving,
      }
    default:
      return createStoryModal
  }
}
